exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".el-radio,.el-radio__label{color:#0B5BAC !important}.el-radio__input.is-checked .el-radio__inner{border-color:#0B5BAC;background:#0B5BAC}.selected span{color:#0B5BAC}.titleEdit{color:#606266 !important}.form{padding:18px 18px}\n", ""]);

// exports
